import React, { Component } from "react";

export default class About extends Component {
  componentDidMount() {
    window.contentWayPoint();
  }

  render() {
    return (
      <div id="About">
        <section className="About" data-section="About">
          <div className="About">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="row row-bottom-padded-sm animate-box"
                  data-animate-effect="fadeInLeft"
                >
                  <div className="col-md-12">
                    <div className="about-desc">
                      <div
                        className="logo"
                        alt="Nick Tu"
                        title="Nick Tu"
                        style={{
                          backgroundImage: "url(/images/me.jpg)",
                        }}
                      />
                      <p>
                        We specialize in Mobile, Windows, and Web application development using C#, ASP.NET, React, Flutter, SQL, JSON, and XML.
                      </p>
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="About">
          <div className="About">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <h2 className="heading">What we do</h2>
              </div>
            </div>
            <div className="row row-pt-md">
              <div className="col-md-4 animate-box">
                <div className="services color-3">
                  <span className="icon">
                    <i className="icon-phone3" />
                  </span>
                  <div className="desc">
                    <h3>IOS and Android Apps</h3>
                    <p>
                      Whether it's for productivity or gaming, we design and
                      develop great apps!
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-5 animate-box">
                <div className="services color-5">
                  <span className="icon">
                    <i className="icon-data" />
                  </span>
                  <div className="desc">
                    <h3>Desktop and Database Development</h3>
                    <p>
                      We develop custom solutions to automate and enhance your
                      company's productivity.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-5 animate-box">
                <div className="services color-1">
                  <span className="icon">
                    <i className="icon-bulb" />
                  </span>
                  <div className="desc">
                    <h3>Web Development</h3>
                    <p>
                      We use the latest technologies in web development to bring
                      you a dynamic and responsive website.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
